import {CheckboxControl, PanelBody, Slot} from '@wordpress/components';
import {FillProps} from './Edit';
import {BlockEditProps} from '@wordpress/blocks';
import {Attr} from './block';
import {__} from '@wordpress/i18n';

export type DisplayOptions = {
	'current-parent-only': boolean;
	'display-no-current': boolean;
	'top-level-siblings': boolean;
}

type Props = Pick<BlockEditProps<Attr>, 'attributes' | 'setAttributes' | 'clientId' | 'name'>

const ErrorBoundary = window.ADVANCED_SIDEBAR_MENU.ErrorBoundary;

const Display = ( {attributes, setAttributes, clientId, name}: Props ) => {
	return (
		<PanelBody title={__( 'Display', 'advanced-sidebar-menu' )}>
			<CheckboxControl
				label={__( 'Display current item\'s section only', 'advanced-sidebar-menu' )}
				help={__( 'Only display the current item and any parents, grandparents, siblings or children of the current item.', 'advanced-sidebar-menu' )}
				checked={attributes[ 'current-parent-only' ]}
				onChange={value => {
					setAttributes( {
						'current-parent-only': value,
					} );
				}} />

			{attributes[ 'current-parent-only' ] && <>
				<CheckboxControl
					label={__( 'Display top-level siblings', 'advanced-sidebar-menu' )}
					help={__( 'Display top-level menu items when on a top-level menu item with no children.', 'advanced-sidebar-menu' )}
					checked={attributes[ 'top-level-siblings' ]}
					onChange={value => {
						setAttributes( {
							'top-level-siblings': value,
						} );
					}} />
				<CheckboxControl
					label={__( 'Display top-level items when not viewing a menu item', 'advanced-sidebar-menu' )}
					help={__( 'Display the top-level menu items when viewing a page that is not part of the menu.', 'advanced-sidebar-menu' )}
					checked={attributes[ 'display-no-current' ]}
					onChange={value => {
						setAttributes( {
							'display-no-current': value,
						} );
					}} />
			</>}

			<ErrorBoundary
				attributes={attributes}
				block={name}
				section={'navigation/Display/display'}
			>
				<Slot<FillProps>
					name="advanced-sidebar-menu/navigation/display"
					fillProps={{
						clientId,
						attributes,
						setAttributes,
					}} />
			</ErrorBoundary>
		</PanelBody>
	);
};

export default Display;
